// navigation
jQuery(function($){

	  /*-----------------------------------------------------------------------------------*/
  /* Mobile Menu
    /*-----------------------------------------------------------------------------------*/
	$(".overlay-btn, .menu-slide-button, .slide-menu-overlay").on("click", function () {
		$(".slide-menu").toggleClass("slide-open");
		$(".slide-menu-overlay").toggleClass("overlay-active");
		$("body").toggleClass("active-slide-menu");
	  });

	// Hide mobile menu on larger screens
	$(window).on('resize', function(){
		var win = $(this); //this = window
		
		if (win.width() >= 1024 && $('body.active-slide-menu').length) {
            $(".slide-menu").removeClass("slide-open");
            $(".slide-menu-overlay").removeClass("overlay-active");
            $("body").removeClass("active-slide-menu");
		}

	});

});


// Hide Menu Before Leaving The Page
jQuery(window).unload(function(){

    $('html').removeClass('overlay-show');

});